import { cn } from '~/lib/utils';

export function GameIntro({
  title,
  description,
  className,
}: {
  title: string;
  description: string;
  className?: string;
}) {
  return (
    <div className={cn('mx-auto mb-5 max-w-md sm:mb-6', className)}>
      <h2 className='heading-sm text-balance text-center'>{title}</h2>
      <p className='text-muted-foreground mx-auto mt-2 text-balance text-center'>{description}</p>
    </div>
  );
}
